import React, { useState } from "react";
import Header from "components/Headers/Header";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Input,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import { Select } from "@mui/material";
import { useDispatch } from "react-redux";
import { addNewsSuggestions } from "store/actions/newsSuggestionactions";
import { ClassNames } from "@emotion/react";

function NewsSuggestions() {
  const dispatch = useDispatch();
  const [suggestionType, setSuggestionType] = useState("");
  const [suggestionText, setSuggestionText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = (e) => {
    e.preventDefault();
    let Suggestions = {
      type: suggestionType,
      remarks: suggestionText,
    };
    setIsLoading(true);
    dispatch(
      addNewsSuggestions(Suggestions, () => {
        setIsLoading(false);
        setSuggestionType("");
        setSuggestionText("");
      })
    );
  };

  return (
    <>
      <Header />
      <Container className="text-center">
        <h1 className="ml-4">News Suggestions</h1>
        <Form className="ml-4" onSubmit={handleSubmit}>
          <Row className="justify-content-center">
            <Col lg="4">
              <Input
                id="suggestionType"
                type="select"
                value={suggestionType}
                onChange={(e) => setSuggestionType(e.target.value)}
              >
                <option value="">Select a type</option>
                <option value="National News">National News</option>
                <option value="State News">State News</option>
                <option value="City Or County News">City Or County News</option>
                <option value="NEWS FOR ALL SPORTS OR SPECIFIC SPORT">
                  NEWS FOR ALL SPORTS OR SPECIFIC SPORT{" "}
                </option>
                <option value="NEWS FOR ALL School">
                  NEWS FOR ALL School{" "}
                </option>
                <option value="NEWS FOR ALL College">
                  NEWS FOR ALL College{" "}
                </option>
              </Input>
            </Col>
          </Row>
          <Card className="text-center shadow-lg w-75 p-5 mt-4 mb-4 mx-auto">
            <Row className="d-block mt-0">
              <Col xs="12">
                <h3 className="text-center mb-3">
                  Especially wanted are any stories of benefits of
                  FansHelpPlayers.com to users.
                </h3>
              </Col>
              <Col lg="12" className="text-left d-flex flex-column">
                <Label htmlFor="suggestionText">Write your Suggestions:</Label>
                <textarea
                  id="suggestionText"
                  value={suggestionText}
                  onChange={(e) => setSuggestionText(e.target.value)}
                  rows="10"
                  placeholder="Enter Suggestions"
                  className="w-100"
                />
              </Col>
            </Row>
          </Card>
          <div className="text-right">
            <Button type="submit" color="primary">
              {isLoading == true ? <Spinner size="sm" /> : "Submit"}
            </Button>
          </div>
        </Form>
      </Container>
    </>
  );
}

export default NewsSuggestions;
